const Const = {
    RETURN_DESCRIPTION_SET_REFUND: 'RETURN_DESCRIPTION_SET_REFUND',
    RETURN_DESCRIPTION_SET_REDUCED_SUM: 'RETURN_DESCRIPTION_SET_REDUCED_SUM',
    RETURN_DESCRIPTION_CLEAR_REFUND: 'RETURN_DESCRIPTION_CLEAR_REFUND',
};

export default Const;
